import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
//import "./Carrera.css";
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

//Rutas de ingreso de matriz
const UrlListarEvaluaciones = ApiUrl + "listarevaluacionesactivas" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInsertarSubcriterio = ApiUrl + "insertarsubcriterio" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListaCriteriosxEvaluacion = ApiUrl + "listarcriteriosxevaluacion" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarSubcritxEvalCritAdm = ApiUrl + "listarsubcritxevalcritadm" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarIndicadoresexSubcrit = ApiUrl + "listarindicadoresexsubcrit" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInsertarIndicadore = ApiUrl + "insertarindicadore" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarEvidenciasxInd = ApiUrl + "listarevidenciasxind" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarUsuarioAdm = ApiUrl + "listusuariosadm" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInsertarEvidencia = ApiUrl + "insertarevidencia" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarMediosVerifexEvid = ApiUrl + "listarmediosverifexevid" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlInsertarMedioVerificacione = ApiUrl + "insertarmedioverificacione" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 3;

export default class GestionSubcritIndicador extends Component {

    constructor(props) {
        super(props)

        this.state = {
            pagina: 0,
            modalReportIngresarSubcrit: false,
            modalReportIngresarInd: false,
            modalReportIngresarEvid: false,
            modalReportIngresarMedv: false,
            eval_seleccionada: '',
            criterio_seleccionado: '',
            ind_seleccionado: '',
            idsubcrit_seleccionado: '',
            descsubcrit_seleccionado: '',
            evid_seleccionada: '',
            administrativos: [],
            nombre_criterio: '',
            nombre_evaluacion: '',
            //nuevas variables
            listaeval: [],
            listacriterios: [],
            listaindicadorese: [],
            listaevidencias: [],
            listamedios: [],
            porcentaje_criterio: 0,
            color_criterio: "",
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
            disableForm: true,
            disableForm2: true,
            disableForm3: true,
            disableForm4: true,
            archivo_medver: ""
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
    }

    handleChangeFile = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ archivo_medver: e.target.files });
    }

    handleChangeDevolverIdEval = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ eval_seleccionada: this.state.idEval });
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data-nombre');
        this.setState({ nombre_evaluacion: option })
        this.handleChangeListarCriteriosxEvaluacion();
    }

    handleChangeDevolverIdCriterio = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ criterio_seleccionado: this.state.idCriterio });
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data-nombre');
        this.setState({ nombre_criterio: option })
    }

    handleChangeListarIndicadorese = async (e) => {
        axios
            .post(UrlListarIndicadoresexSubcrit, {
                id_subcrit: this.state.idsubcrit_seleccionado,
            })
            .then(response => {
                this.setState({ listaindicadorese: response.data.data })
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    seleccionarSubcriteriouno = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        var id_subcrit = "";
        var desc_subcrit = "";

        $(".afiliado:checked").each(function () {
            id_subcrit = $(this).parent().parent().find('td').eq(0).html();
            desc_subcrit = $(this).parent().parent().find('td').eq(1).html();
        });

        this.setState({ idsubcrit_seleccionado: id_subcrit })
        this.setState({ descsubcrit_seleccionado: desc_subcrit })

        this.handleChangeListarIndicadorese();
        this.setState({ disableForm2: false });
    }

    handleChangeListarSubcritxEvalCritAdm = async (e) => {
        this.setState({ disableForm2: true });
        this.setState({ disableForm3: true });
        this.setState({ disableForm4: true });
        axios
            .post(UrlListarSubcritxEvalCritAdm, {
                id_evaluacion: this.state.eval_seleccionada,
                id_criterio: this.state.criterio_seleccionado,
            })
            .then(response => {
                listaauxiliar = response.data.data;
                this.setState({ porcentaje_criterio: response.data.data1 });
                this.setState({ color_criterio: response.data.data2 });

                //PAGINACION
                this.state.itemOffset = 0;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
        this.setState({ disableForm: false });
    }

    handleChangeListarSubcritSinCerrar = async (e) => {
        axios
            .post(UrlListarSubcritxEvalCritAdm, {
                id_evaluacion: this.state.eval_seleccionada,
                id_criterio: this.state.criterio_seleccionado,
            })
            .then(response => {
                listaauxiliar = response.data.data;
                this.setState({ porcentaje_criterio: response.data.data1 });
                this.setState({ color_criterio: response.data.data2 });

                //PAGINACION
                this.state.itemOffset = 0;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
        this.setState({ disableForm: false });
    }

    handleChangeListarEvaluaciones = async (e) => {
        //planes
        axios.get(UrlListarEvaluaciones)
            .then(respuesta => {
                this.setState({ listaeval: respuesta.data.data });
            })
    }

    handleChangeListarCriteriosxEvaluacion = async (e) => {
        //criterios
        axios
            .post(UrlListaCriteriosxEvaluacion, {
                id: this.state.eval_seleccionada,
            })
            .then(response => {
                this.setState({ listacriterios: response.data.data });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        this.handleChangeListarEvaluaciones();
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        this.setState({ pagina: event.selected });
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION

    mostrarModalIngresar = () => {
        this.setState({ id: 0 });
        this.setState({ subcriterio: null });
        this.setState({ modalReportIngresarSubcrit: true });
    }

    mostrarModalIngresarInd = () => {
        this.setState({ id_ind: 0 });
        this.setState({ desc_ind: null });
        this.setState({ modalReportIngresarInd: true });
    }

    mostrarModalModificar = (registro) => {
        $(function () {
            $("#id").val(registro.evaluacionescriteriosadm_subcriterio);
            $("#criterio").val(registro.id_criterio);
            $("#subcriterio").val(registro.descripcion_subcriterio);
        });

        this.setState({ id: registro.evaluacionescriteriosadm_subcriterio });
        this.setState({ criterio: registro.id_criterio });
        this.setState({ subcriterio: registro.descripcion_subcriterio });
        this.setState({ modalReportIngresarSubcrit: true });
    }

    mostrarModalModificarInd = (registro) => {
        $(function () {
            $("#id_ind").val(registro.id_indicadore);
            $("#desc_ind").val(registro.descripcion_indicadore);
        });

        this.setState({ id_ind: registro.id_indicadore });
        this.setState({ desc_ind: registro.descripcion_indicadore });
        this.setState({ modalReportIngresarInd: true });
    }

    ocultarModalIngresar = () => {
        this.setState({ modalReportIngresarSubcrit: false });
    }

    ocultarModalIngresarInd = () => {
        this.setState({ modalReportIngresarInd: false });
    }

    registrarSubcriterio = () => {
        if (this.state.subcriterio != null) {
            const f = new FormData();
            f.append("id", this.state.id);
            f.append("id_evaluacion", this.state.eval_seleccionada);
            f.append("id_criterio", this.state.criterio_seleccionado);
            f.append("subcriterio", this.state.subcriterio);

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            axios.post(urlInsertarSubcriterio, f, config)
                .then(response => {
                    if (response.data.success === true) {
                        swal({
                            text: "Operación Exitosa!!",
                            icon: "success",
                            button: "Aceptar",
                        });
                        axios.post(UrlListarSubcritxEvalCritAdm, {
                            id_evaluacion: this.state.eval_seleccionada,
                            id_criterio: this.state.criterio_seleccionado,
                        })
                            .then(respuesta => {
                                listaauxiliar = respuesta.data.data;
                                if (this.state.pageCount == 1) {
                                    this.setState({ itemOffset: 0 });
                                }

                                //PAGINACION
                                const newOffset = (this.state.pagina * itemsPerPage) % listaauxiliar.length;
                                this.setState((state) => {
                                    return { itemOffset: newOffset }
                                });
                                const endOffset = newOffset + itemsPerPage;
                                //const endOffset = (this.state.pageCount * itemsPerPage) % listaauxiliar.length;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                this.setState({ itemOffset: newOffset });
                            })
                        this.ocultarModalIngresar();
                    }
                })
                .catch(error => {
                    this.setState({ error: "No existe conexión con el servidor" });
                    swal({
                        text: "No existe conexión con el servidor",
                        icon: "error",
                        button: "Aceptar",
                    });
                });
        }
        else {
            swal({
                text: "Ingresar campos requeridos",
                icon: "warning",
                button: "Aceptar",
            });
        }
    }

    registrarIndicador = () => {
        if (this.state.desc_ind != null) {
            const f = new FormData();
            f.append("id", this.state.id_ind);
            f.append("desc_ind", this.state.desc_ind);
            f.append("subcriterio_id", this.state.idsubcrit_seleccionado);

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            axios.post(urlInsertarIndicadore, f, {

            }, config)
                .then(response => {
                    if (response.data.success === true) {
                        this.handleChangeListarIndicadorese();
                        this.ocultarModalIngresarInd();
                    }
                })
                .catch(error => {
                    this.setState({ error: "No existe conexión con el servidor" });
                    swal({
                        text: "No existe conexión con el servidor",
                        icon: "error",
                        button: "Aceptar",
                    });
                });
        }
        else {
            swal({
                text: "Ingresar campos requeridos",
                icon: "warning",
                button: "Aceptar",
            });
        }
    }

    seleccionarIndicadoruno = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        var id_ind = "";
        var desc_ind = "";

        $(".afiliado:checked").each(function () {
            id_ind = $(this).parent().parent().find('td').eq(0).html();
            desc_ind = $(this).parent().parent().find('td').eq(1).html();
        });

        this.setState({ ind_seleccionado: id_ind })

        this.handleChangeListarEvidenciasxInd();
        this.setState({ disableForm3: false });
    }

    handleChangeListarAdm() {
        axios.get(UrlListarUsuarioAdm)
            .then(res => {
                const administrativos = res.data.data;
                this.setState({ administrativos });
            })
    }

    handleChangeListarEvidenciasxInd = async (e) => {
        this.handleChangeListarAdm();

        axios
            .post(urlListarEvidenciasxInd, {
                id: this.state.ind_seleccionado,
            })
            .then(response => {
                this.setState({ listaevidencias: response.data.data });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            })
    }

    mostrarModalIngresarEvid = () => {
        this.setState({ id: 0 });
        this.setState({ descripcion: null });
        this.setState({ responsable: null });
        this.setState({ fentrega: null });
        this.setState({ estadoevid: null });
        this.setState({ observaciones: "" });
        this.setState({ modalReportIngresarEvid: true });
    }

    mostrarModalModificarEvid = (registro) => {
        var vfentrega = registro.fechaentrega_evidencia;
        var vobser = registro.observ_evidencia;
        if (vfentrega == null) {
            vfentrega = "";
        }

        if (vobser == null) {
            vobser = "";
        }
        $(function () {
            $("#id").val(registro.id_evidencia);
            $("#detalle").val(registro.detalle_evidencia);
            $("#responsable").val(registro.id_administrativo);
            $("#fentrega").val(vfentrega);
            $("#estadoevid").val(registro.estado_evidencia);
            $("#observaciones").val(vobser);
        });

        this.setState({ id: registro.id_evidencia });
        this.setState({ detalle: registro.detalle_evidencia });
        this.setState({ responsable: registro.id_administrativo });
        this.setState({ fentrega: vfentrega });
        this.setState({ estadoevid: registro.estado_evidencia });
        this.setState({ observaciones: vobser });
        this.setState({ modalReportIngresarEvid: true });
    }

    ocultarModalIngresarEvid = () => {
        this.setState({ modalReportIngresarEvid: false });
    }

    registrarEvidencia = () => {

        if (this.state.detalle != null && this.state.responsable != null && this.state.fentrega != null && this.state.estadoevid != null) {
            const f = new FormData();
            f.append("id", this.state.id);
            f.append("detalle", this.state.detalle);
            f.append("responsable", this.state.responsable);
            f.append("fechaentrega", this.state.fentrega);
            f.append("estadoevid", this.state.estadoevid);
            f.append("observaciones", this.state.observaciones);
            f.append("indicador", this.state.ind_seleccionado);

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            axios.post(urlInsertarEvidencia, f, {

            }, config)
                .then(response => {
                    if (response.data.success === true) {
                        swal({
                            text: "Operación Exitosa!!",
                            icon: "success",
                            button: "Aceptar",
                        });
                        this.handleChangeListarEvidenciasxInd();
                        this.ocultarModalIngresarEvid();
                    }
                })
                .catch(error => {
                    this.setState({ error: "No existe conexión con el servidor" });
                    swal({
                        text: "No existe conexión con el servidor",
                        icon: "error",
                        button: "Aceptar",
                    });
                });
        }
        else {
            swal({
                text: "Ingresar campos requeridos",
                icon: "warning",
                button: "Aceptar",
            });
        }
    }

    handleChangeListarMediosVerife = async (e) => {
        axios
            .post(UrlListarMediosVerifexEvid, {
                id_evidencia: this.state.evid_seleccionada,
            })
            .then(response => {
                this.setState({ listamedios: response.data.data })
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    seleccionarEvidenciauno = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        var id_evidencia = "";
        var desc_evidencia = "";

        $(".afiliado:checked").each(function () {
            id_evidencia = $(this).parent().parent().find('td').eq(0).html();
            desc_evidencia = $(this).parent().parent().find('td').eq(1).html();
        });

        this.setState({ evid_seleccionada: id_evidencia })
        this.setState({ descevid_seleccionada: desc_evidencia })

        this.handleChangeListarMediosVerife();
        this.setState({ disableForm4: false });
    }

    mostrarModalIngresarMedVer = () => {
        this.setState({ id_medver: 0 });
        this.setState({ desc_medver: null });
        this.setState({ archivo_medver_mod: "" });
        this.setState({ obser_medver: "" });
        this.setState({ estado_medver: null });
        this.setState({ modalReportIngresarMedv: true });
    }

    ocultarModalIngresarMedVer = () => {
        this.setState({ modalReportIngresarMedv: false });
    }

    mostrarModalModificarMedVer = (registro) => {
        var vobservaciones = registro.obser_medioverificacione;
        if (vobservaciones == null) {
            vobservaciones = "";
        }
        var varchivo = registro.archivo_medioverificacione;
        if (varchivo == null) {
            varchivo = "";
        }
        $(function () {
            $("#id_medver").val(registro.id_medioverificacione);
            $("#desc_medver").val(registro.desc_medioverificacione);
            $("#archivo_medver_mod").val(varchivo);
            $("#obser_medver").val(vobservaciones);
            $("#estado_medver").val(registro.estado_medioverificacione);
        });

        this.setState({ id_medver: registro.id_medioverificacione });
        this.setState({ desc_medver: registro.desc_medioverificacione });
        this.setState({ archivo_medver_mod: varchivo });
        this.setState({ obser_medver: vobservaciones });
        this.setState({ estado_medver: registro.estado_medioverificacione });
        this.setState({ modalReportIngresarMedv: true });
    }

    VerificarExtensionArchivo = () => {
        var narchivo = 0;
        if (this.state.archivo_medver != "") {
            var fileInput = document.getElementById('archivo_medver');
            var filePath = fileInput.value;
            var allowedExtensions = /(.pdf)$/i;
            if ((!allowedExtensions.exec(filePath)) && (this.state.idTipoTransacciont != 3)) {
                swal({
                    text: "El archivo debe ser formato PDF",
                    icon: "error",
                    button: "Aceptar",
                });
                this.setState({ varchivo: 1 });
                narchivo = 1;
            }
        }
        return (narchivo);
    }

    registrarMedioVerificacion = () => {
        if (this.VerificarExtensionArchivo() != 1) {
            if (this.state.desc_medver != null && this.state.estado_medver != null) {
                const f = new FormData();
                f.append("id_medver", this.state.id_medver);
                f.append("desc_medver", this.state.desc_medver);
                f.append("archivo_medver", this.state.archivo_medver[0]);
                f.append("obser_medver", this.state.obser_medver);
                f.append("estado_medver", this.state.estado_medver);
                f.append("evidencia_id", this.state.evid_seleccionada);
                f.append("archivo_medver_mod", this.state.archivo_medver_mod);

                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                axios.post(UrlInsertarMedioVerificacione, f, config)
                    .then(response => {
                        if (response.data.success === true) {
                            swal({
                                text: "Operación Exitosa!!",
                                icon: "success",
                                button: "Aceptar",
                            });
                            this.handleChangeListarSubcritSinCerrar();
                            this.handleChangeListarIndicadorese();
                            this.handleChangeListarEvidenciasxInd();
                            this.handleChangeListarMediosVerife();
                            this.ocultarModalIngresarMedVer();
                        }
                    })
                    .catch(error => {
                        this.setState({ error: "No existe conexión con el servidor" });
                        swal({
                            text: "No existe conexión con el servidor",
                            icon: "error",
                            button: "Aceptar",
                        });
                    });
            } else {
                swal({
                    text: "Ingresar campos requeridos",
                    icon: "warning",
                    button: "Aceptar",
                });
            }
        }
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">

                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas">
                        <i className="fa fa-chart-line bounce-custom fs-5"></i>
                        <b className="mb-0 fw-semibold"> Gestión de Subcriterios por Evaluación</b>
                    </div>

                    <div className="p-3 rounded-3 mt-3">

                        <div className="row">
                            <div className="col-xl-4 mb-3">
                                <label className="form-label text-azul fw-bold">Evaluaciones</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idEval"
                                    value={this.state.value}
                                    onChange={this.handleChangeDevolverIdEval}
                                    aria-label="Default select example"
                                >
                                    <option value="undefined" selected disabled>Seleccione una evaluación</option>
                                    {this.state.listaeval.map(person => (
                                        <option key={person.id_evaluacion} data-nombre={person.nombre_evaluacion} value={person.id_evaluacion}>
                                            {person.nombre_evaluacion}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-xl-4 mb-3">
                                <label className="form-label text-azul fw-bold">Criterio</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCriterio"
                                    value={this.state.value}
                                    onChange={this.handleChangeDevolverIdCriterio}
                                    aria-label="Default select example"
                                >
                                    <option value="undefined" selected disabled>Seleccione un criterio</option>
                                    {this.state.listacriterios.map(person => (
                                        <option key={person.id_criterio} data-nombre={person.nombre_criterio} value={person.id_criterio}>
                                            {person.nombre_criterio}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-xl-4 mb-3 d-flex align-items-end">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                    style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                    onClick={this.handleChangeListarSubcritxEvalCritAdm}
                                >
                                    Consultar
                                </button>
                            </div>
                        </div>
                        <div className="card border-1 text-center" hidden={this.state.disableForm}>
                            <div className={`card-header text-white ${this.state.color_criterio} py-0`}>
                                <b>PORCENTAJE DEL CRITERIO: {this.state.porcentaje_criterio}%</b>
                            </div>
                            <div className="card-header">
                                <h6 className="fw-bold text-center mb-0 text-azul">Reporte de Subcriterios</h6>
                            </div>

                            {/* Tabla Subcriterios */}
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start text-azul">#</th>
                                            <th className="text-start text-azul">Nombre</th>
                                            <th className="text-center text-azul">Porcentaje</th>
                                            <th className="text-center text-azul">Seleccionar</th>
                                            <th className="text-center text-azul">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentItems && this.state.currentItems.map((consola) => (
                                            <tr key={consola.id_subcriterio}>
                                                <td className="text-start text-azul">{consola.id_subcriterio}</td>
                                                <td className="text-start text-azul">{consola.descripcion_subcriterio}</td>
                                                <td className={`text-center ${consola.color}`}>{consola.porcentaje_subcrit}%</td>
                                                <td className="text-center">
                                                    <input type="radio" value="1" name="afiliado" onChange={this.seleccionarSubcriteriouno} className="afiliado" />
                                                </td>
                                                <td className="text-center">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => this.mostrarModalModificar(consola)}
                                                        title="Ver/Editar subcriterio"
                                                        style={{ borderRadius: "10px" }}
                                                    >
                                                        <i className="fas fa-clipboard-list"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Paginación */}
                            <div className="d-flex justify-content-center mt-2">
                                <ReactPaginate
                                    previousLabel="<"
                                    nextLabel=">"
                                    pageCount={this.state.pageCount}
                                    onPageChange={this.handlePageClick}
                                    containerClassName="pagination pagination-sm-custom"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    activeClassName="active"
                                    renderOnZeroPageCount={null}
                                />
                            </div>

                            {/* Modal Registro Subcriterio */}
                            <Modal isOpen={this.state.modalReportIngresarSubcrit}>
                                <ModalHeader>Registro de Subcriterio por Evaluación</ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <div className="mb-3 centrar">
                                            <input type="hidden" name="id" className="id" id="id" value="" />
                                            <label className="form-label text-azul">Evaluación:</label>
                                            <input type="text" id="evaluacion" name="evaluacion" value={this.state.nombre_evaluacion} className="form-control" disabled />
                                            <label className="form-label text-azul">Criterio:</label>
                                            <input type="text" id="criterioe" name="criterioe" value={this.state.nombre_criterio} className="form-control" disabled />
                                            <label className="form-label text-azul">Subcriterio:</label>
                                            <input type="text" id="subcriterio" name="subcriterio" onChange={this.handleChange} className="form-control" required />
                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <button type="button" className="btn btn-outline-primary" onClick={() => this.registrarSubcriterio()}>Ingresar</button>
                                    <button type="button" className="btn btn-outline-primary" onClick={() => this.ocultarModalIngresar()}>Salir</button>
                                </ModalFooter>
                            </Modal>

                            {/* Botón Registrar */}
                            <div className="text-center mt-2">
                                <button
                                    id="agregar"
                                    type="button"
                                    className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                    style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                    onClick={() => this.mostrarModalIngresar()}
                                >
                                    <i className="fas fa-plus me-1"></i>Registrar
                                </button>
                            </div>
                        </div>

                        <br />
                        <div className="card border-1 text-center" hidden={this.state.disableForm2}>
                            <div className="card-header">
                                <b>Reporte de Indicadores por Subcriterio</b>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start text-azul">#</th>
                                            <th className="text-start text-azul">Nombre</th>
                                            <th className="text-center text-azul">Porcentaje</th>
                                            <th className="text-center text-azul">Seleccionar</th>
                                            <th className="text-center text-azul">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listaindicadorese.map((consola) => (
                                            <tr key={consola.id_indicadore}>
                                                <td className="text-start text-azul">{consola.id_indicadore}</td>
                                                <td className="text-start text-azul">{consola.descripcion_indicadore}</td>
                                                <td className={`text-center ${consola.color}`}>{consola.porcentaje_ind}%</td>
                                                <td className="text-center">
                                                    <input type="radio" value="1" name="afiliado" onChange={this.seleccionarIndicadoruno} className="afiliado" />
                                                </td>
                                                <td className="text-center">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => this.mostrarModalModificarInd(consola)}
                                                        title="Ver/Editar indicador"
                                                        style={{ borderRadius: "10px" }}
                                                    >
                                                        <i className="fas fa-clipboard-list"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Modal isOpen={this.state.modalReportIngresarInd}>
                                    <ModalHeader>Registro de Indicadores por Subcriterio</ModalHeader>
                                    <ModalBody>
                                        <FormGroup>
                                            <div className="mb-3 centrar">
                                                <input type="hidden" name="id_ind" className="id_ind" id="id_ind" value="" />
                                                <label className="form-label text-azul">Subcriterio:</label>
                                                <textarea id="subcriterio" name="subcriterio" value={this.state.descsubcrit_seleccionado} onChange={this.handleChange} className="form-control" disabled required></textarea>
                                                <label className="form-label text-azul">Indicador:</label>
                                                <input type="text" id="desc_ind" name="desc_ind" onChange={this.handleChange} className="form-control" required />
                                            </div>
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button type="button" className="btn btn-outline-primary" onClick={() => this.registrarIndicador()}>Ingresar</button>
                                        <button type="button" className="btn btn-outline-primary" onClick={() => this.ocultarModalIngresarInd()}>Salir</button>
                                    </ModalFooter>
                                </Modal>

                                <div className="text-center mt-3">
                                    <button
                                        id="agregar"
                                        type="button"
                                        className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                        style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                        onClick={() => this.mostrarModalIngresarInd()}
                                    >
                                        <i className="fas fa-plus me-1"></i>Registrar
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="card border-1 text-center" hidden={this.state.disableForm3}>
                            <div className="card-header">
                                <h6 className="fw-bold text-center mb-0 text-azul">Reporte de Evidencias</h6>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start text-azul">#</th>
                                            <th className="text-start text-azul">Descripción</th>
                                            <th className="text-start text-azul">Responsable</th>
                                            <th className="text-start text-azul">Fecha de Entrega</th>
                                            <th className="text-center text-azul">Estado</th>
                                            <th className="text-center text-azul">Observaciones</th>
                                            <th className="text-center text-azul">Metas</th>
                                            <th className="text-center text-azul">Seleccionar</th>
                                            <th className="text-center text-azul">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listaevidencias.map((consola) => (
                                            <tr key={consola.id_evidencia}>
                                                <td className="text-start text-azul">{consola.id_evidencia}</td>
                                                <td className="text-start text-azul">{consola.detalle_evidencia}</td>
                                                <td className="text-start text-azul">{consola.nombres_administrativo} {consola.apellidos_administrativo}</td>
                                                <td className="text-start text-azul">{consola.fechaentrega_evidencia}</td>
                                                <td className="text-center">{consola.estado_evidencia}</td>
                                                <td className="text-center">{consola.observ_evidencia}</td>
                                                <td className={`text-center ${consola.color}`}>{consola.porcentaje}%</td>
                                                <td className="text-center">
                                                    <input type="radio" value="1" name="afiliado" onChange={this.seleccionarEvidenciauno} className="afiliado" />
                                                </td>
                                                <td className="text-center">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => this.mostrarModalModificarEvid(consola)}
                                                        title="Ver/Editar evidencia"
                                                        style={{ borderRadius: "10px" }}
                                                    >
                                                        <i className="fas fa-clipboard-list"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Modal isOpen={this.state.modalReportIngresarEvid}>
                                    <ModalHeader>Registro de Evidencia</ModalHeader>
                                    <ModalBody>
                                        <FormGroup>
                                            <div className="mb-3 centrar">
                                                <input type="hidden" name="id" className="id" id="id" value="" />
                                                <label className="form-label text-azul">Detalle:</label>
                                                <input type="text" id="detalle" name="detalle" onChange={this.handleChange} className="form-control" required />
                                                <label className="form-label text-azul">Responsable:</label>
                                                <select className="form-select" id="responsable" name="responsable" value={this.state.value} onChange={this.handleChange} aria-label="Default select example" required>
                                                    <option value="">Seleccione</option>
                                                    {this.state.administrativos.map(person => (
                                                        <option key={person.id_administrativo} value={person.id_administrativo}>
                                                            {person.nombres_administrativo} {person.apellidos_administrativo}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label className="form-label text-azul">Fecha de entrega:</label>
                                                <input type="date" id="fentrega" name="fentrega" onChange={this.handleChange} className="form-control" required />
                                                <label className="form-label text-azul">Estado:</label>
                                                <select className="form-select" id="estadoevid" name="estadoevid" value={this.state.value} onChange={this.handleChange} required>
                                                    <option value="" selected disabled>Seleccione</option>
                                                    <option value="Pendiente">Pendiente</option>
                                                    <option value="Cumple">Cumple</option>
                                                    <option value="Cumple Parcialmente">Cumple Parcialmente</option>
                                                    <option value="No Cumple">No Cumple</option>
                                                </select>
                                                <label className="form-label text-azul">Observaciones:</label>
                                                <textarea id="observaciones" name="observaciones" onChange={this.handleChange} className="form-control" required></textarea>
                                            </div>
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button type="button" className="btn btn-outline-primary" onClick={() => this.registrarEvidencia()}>Ingresar</button>
                                        <button type="button" className="btn btn-outline-primary" onClick={() => this.ocultarModalIngresarEvid()}>Salir</button>
                                    </ModalFooter>
                                </Modal>

                                <div className="text-center mt-3">
                                    <button
                                        id="agregar"
                                        type="button"
                                        className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                        style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                        onClick={() => this.mostrarModalIngresarEvid()}
                                    >
                                        <i className="fas fa-plus me-1"></i>Registrar
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="card border-1 text-center" hidden={this.state.disableForm4}>
                            <div className="card-header">
                                <h6 className="fw-bold text-center mb-0 text-azul">Reporte de Medios de Verificación</h6>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start text-azul">#</th>
                                            <th className="text-start text-azul">Descripción</th>
                                            <th className="text-center text-azul">Archivo</th>
                                            <th className="text-center text-azul">Observaciones</th>
                                            <th className="text-center text-azul">Estado</th>
                                            <th className="text-center text-azul">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listamedios.map((consola) => (
                                            <tr key={consola.id_medioverificacione}>
                                                <td className="text-start text-azul">{consola.id_medioverificacione}</td>
                                                <td className="text-start text-azul">{consola.desc_medioverificacione}</td>
                                                <td className="text-center">
                                                    {consola.ruta && (
                                                        <a href={consola.ruta} target="_blank" rel="noopener noreferrer">
                                                            <i className="fa fa-2x fa-file-pdf" aria-hidden="true"></i>
                                                        </a>
                                                    )}
                                                </td>
                                                <td className="text-center">{consola.obser_medioverificacione}</td>
                                                <td className="text-center">
                                                    <span className={`badge ${consola.estado_medioverificacione === "Pendiente" ? "bg-danger" :
                                                            consola.estado_medioverificacione === "Corrección" ? "bg-info" :
                                                                consola.estado_medioverificacione === "Completado" ? "bg-warning" :
                                                                    consola.estado_medioverificacione === "Verificado" ? "bg-success" : "bg-secondary"
                                                        } text-white px-2 py-1`} style={{ borderRadius: "10px", fontSize: "0.75rem" }}>
                                                        {consola.estado_medioverificacione}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => this.mostrarModalModificarMedVer(consola)}
                                                        title="Ver/Editar medio de verificación"
                                                        style={{ borderRadius: "10px" }}
                                                    >
                                                        <i className="fas fa-clipboard-list"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Modal isOpen={this.state.modalReportIngresarMedv}>
                                    <ModalHeader>Registro de Medio de Verificación</ModalHeader>
                                    <ModalBody>
                                        <FormGroup>
                                            <div className="mb-3 centrar">
                                                <input type="hidden" name="id_medver" className="id_medver" id="id_medver" value="" />
                                                <input type="hidden" name="archivo_medver_mod" className="archivo_medver_mod" id="archivo_medver_mod" value="" />
                                                <label className="form-label text-azul">Evidencia:</label>
                                                <textarea id="evidencia" name="evidencia" value={this.state.descevid_seleccionada} onChange={this.handleChange} className="form-control" disabled required></textarea>
                                                <label className="form-label text-azul">Descripción:</label>
                                                <input type="text" id="desc_medver" name="desc_medver" onChange={this.handleChange} className="form-control" required />
                                                <label className="form-label text-azul">Archivo:</label>
                                                <input type="file" id="archivo_medver" name="archivo_medver" onChange={this.handleChangeFile} className="form-control" />
                                                <label className="form-label text-azul">Observaciones:</label>
                                                <textarea id="obser_medver" name="obser_medver" onChange={this.handleChange} className="form-control"></textarea>
                                                <label className="form-label text-azul">Estado:</label>
                                                <select className="form-select" id="estado_medver" name="estado_medver" value={this.state.value} onChange={this.handleChange} required>
                                                    <option value="">Seleccione</option>
                                                    <option value="Pendiente">Pendiente</option>
                                                    <option value="Corrección">Corrección</option>
                                                    <option value="Completado">Completado</option>
                                                    <option value="Verificado">Verificado</option>
                                                </select>
                                            </div>
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button type="button" className="btn btn-outline-primary" onClick={() => this.registrarMedioVerificacion()}>Ingresar</button>
                                        <button type="button" className="btn btn-outline-primary" onClick={() => this.ocultarModalIngresarMedVer()}>Salir</button>
                                    </ModalFooter>
                                </Modal>

                                <div className="text-center mt-3">
                                    <button
                                        id="agregar"
                                        type="button"
                                        className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                        style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                        onClick={() => this.mostrarModalIngresarMedVer()}
                                    >
                                        <i className="fas fa-plus me-1"></i>Registrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

